module.exports = "data:image/png;base64,UklGRtwAAABXRUJQVlA4WAoAAAAQAAAAEwAAEAAAQUxQSJAAAAABf8E4kqQ2rMHD00g/5R8lyiIiMuAmg5BpMV+YK6uWDymz5jd2WJgdRMRPOIwk27T2md+2jc0/u+vzQojof85+7IDJgzJU70AROp6eKcAZLI9Pmvdpt+jfEMjaJofZEmK6o4I0vlIjnKx+NAiOLnQQKNZfuvCi+Z0+3OGRIdhq82cQuly9KKBePSjuP+wAAABWUDggJgAAANACAJ0BKhQAEQA+nUqfSyWkIqGoCACwE4lpAAA9o6AA/vccAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/growthThinking/list2/640(8).png
// module id = UubC
// module chunks = 1